/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartSickNoteAliases {
  CONTEXTUAL_BAR_MEDICAL_AREA = 'contextual-bar-medical-area',
  DECK_SICK_NOTES = 'deck-sick-notes',
  FETCH_SICK_NOTES = 'fetch-sick-notes',
  LAYOUT_MY_CHART_SICK_NOTE = 'layout-my-chart-sick-note',
  PANEL_GENERAL = 'panel-general',
  SICK_NOTES_CARD = 'sick-notes-card',
}
export { MyChartSickNoteAliases };
